<yc-router-resolve-block></yc-router-resolve-block>
<yc-block-ui
  [message]="loadingMessage$ | async"
  [blocking]="blocking$ | async">
</yc-block-ui>
@if (langsResolved) {
  <router-outlet></router-outlet>
}
